import React from 'react'
import AjoutProjetClientSide from '../Client/dashboardComponents/AjoutProjetClientSide'

function AddProject() {
    return (
        <div className='flex justify-center pb-3 pt-6'>
            <div className='w-[95%] bg-gry rounded-md p-2'>
                <div className='header pb-2'>
                    <h1 className='font-sans font-medium text-lg text-blck'>Vous avez un projet, une idée que vous voulez concretiser ? faites le nous savoir...</h1>
                </div>
                <div className='py-1'>
                    <AjoutProjetClientSide />
                </div>
            </div>
        </div>
    )
}

export default AddProject